import React, {useState} from 'react';
import { BrowserRouter, Route, Switch,Link } from 'react-router-dom';
import PopupArticle from './components/PopupArticle';
import Main from './Main';
import News from './News';
import './App.css';
import TwitterIcon from "./Twitter social icons - square - white.png";
import InstagramIcon from "./Instagram_Glyph_White.png";
import KobushiIcon from "./header-kobushi.png";


function App() {
  const [showModal2, setShowModal2] = useState(false); // Modalコンポーネントの表示の状態を定義する
  const ShowModal2=()=>{
    setShowModal2(true);
  }

  return (
    <BrowserRouter>
      <header className="App-header">
        <div className="header-div">
          <div className='header-left'>
              <Link to={`/69/pre/`} className="header-link">HOME</Link>
          </div>
          <div className="header-center">
          <img src={KobushiIcon} className="header-logo"/>
          </div>
          <div className='header-right'>
              <Link to={`/69/pre/news`} className="header-link">NEWS</Link>
          </div>
        </div>
      </header>
      
      <div className='body'>
      <Switch>
        <Route exact path="/69/pre/" component={Main} />
        <Route exact path="/69/pre/news" component={News} />
      </Switch>
      </div>
      
      <footer>
        <div className='footer-left'>
          <img src={KobushiIcon} alt="第69回辛夷祭ロゴ" className="footer-kobushi"/>
          <h1>東京学芸大学附属高等学校</h1>
        </div>
        <div class="footer-right">
           
          <div className="App">  
            <button onClick={ShowModal2} className='footer-button'>お問い合わせ</button>
            <PopupArticle 
              showFlag = {showModal2} 
              setShowModal={setShowModal2} 
              title="お問い合わせ" 
              date="2023年7月1日"
              content="TEL 03-3421-5151　FAX 03-3421-5152"
              content2="kgk2@gakugei-hs.setagaya.tokyo.jp"/>
          </div>
          <a href="https://twitter.com/kobushi2023_69?s=20"><img src={TwitterIcon} alt="Twitter" class="social-icon"/></a>
          <a href="https://www.instagram.com/kobushisai2023_69/"><img src={InstagramIcon} alt="Instagram " class="social-icon"/></a>
        </div>
      </footer>
    </BrowserRouter>
  );
}

export default App;
